import { create } from 'zustand'

const useNavStore = create<{
  showManagement: boolean
  /** User id the role-based default was last applied for. */
  defaultAppliedForUserId: string | null
  setShowManagement: (value: boolean) => void
  /**
   * Applies the default view (Beheer/Platform) for a user ONCE. The navbar
   * remounts when switching between role-based route branches, so applying this
   * on every mount would reset the user's explicit choice.
   */
  applyRoleDefault: (userId: string | null, isHrManager: boolean) => void
  reset: () => void
}>((set, get) => ({
  showManagement: false,
  defaultAppliedForUserId: null,
  setShowManagement: (showManagement: boolean) => set({ showManagement }),
  applyRoleDefault: (userId, isHrManager) => {
    if (!userId || get().defaultAppliedForUserId === userId) return
    // Only HR gets a forced default (Beheer). For everyone else we just record
    // that the default was considered and leave the current value alone, so the
    // path-based sync (e.g. /company-dashboard => Beheer) is not overridden.
    // Child effects run before parent effects, so clobbering here would reset
    // the mode ToggleMenu just derived from the URL.
    if (isHrManager) {
      set({ showManagement: true, defaultAppliedForUserId: userId })
    } else {
      set({ defaultAppliedForUserId: userId })
    }
  },
  reset: () => set({ showManagement: false, defaultAppliedForUserId: null }),
}))

export default useNavStore
